import { render } from "./NormalCards.vue?vue&type=template&id=044f0acd"
import script from "./NormalCards.vue?vue&type=script&lang=js"
export * from "./NormalCards.vue?vue&type=script&lang=js"

import "./NormalCards.vue?vue&type=style&index=0&id=044f0acd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__